import { useFilter } from "Shared/hooks/useFilter"
import { DELIVERY_NOTES_TABLE_FILTERS } from "Shared/services/localstorage.service"
import { DeliveryNoteFilterFormValues } from "Components/forms/filter/DeliveryNoteFilterForm"

export const useDeliveryNoteFilter = () => useFilter<DeliveryNoteFilterFormValues>({ localStorageKey: DELIVERY_NOTES_TABLE_FILTERS })
